import ApolloClientLib from 'apollo-boost'
import config from 'src/config'
import { show } from 'features/Toasts/Toasts.actions.js'

const ApolloClient = (ApolloClientLib as any).default as typeof ApolloClientLib

export const initApolloClient = store =>
  new ApolloClient({
    uri: `${config.api.main}/graphql`,
    request: async operation => {
      const authorization = store.getState().auth.token
      operation.setContext({
        headers: {
          authorization: authorization ? `bearer ${authorization}` : undefined,
        },
      })
    },
    onError: errors => {
      errors.graphQLErrors?.forEach(err => {
        store.dispatch(
          show({
            type: 'error',
            title: err.message,
          })
        )
      })
    },
  })



// WEBPACK FOOTER //
// src/features/Apollo/index.ts